
import { useWorkoutTypeQueries } from './useWorkoutTypeQueries';
import { useWorkoutTypeMutations } from './useWorkoutTypeMutations';
import { WorkoutType } from '@/models/WorkoutType';
import { WorkoutTypeOperations } from './types';

export const useWorkoutTypes = (): WorkoutTypeOperations => {
  const { 
    workoutTypes, 
    loading, 
    error, 
    refetch, 
    checkCanDeleteWorkoutType 
  } = useWorkoutTypeQueries();

  const {
    canManage,
    createWorkoutTypeMutation,
    updateWorkoutTypeMutation,
    deleteWorkoutTypeMutation,
  } = useWorkoutTypeMutations();

  // Handler functions for backward compatibility
  const createWorkoutType = async (workoutTypeData: Partial<WorkoutType>) => {
    try {
      await createWorkoutTypeMutation.mutateAsync(workoutTypeData);
      return true;
    } catch (error) {
      // Error is already handled by the mutation's onError
      console.error('Create workout type error:', error);
      return false;
    }
  };

  const updateWorkoutType = async (id: string, workoutTypeData: Partial<WorkoutType>) => {
    try {
      await updateWorkoutTypeMutation.mutateAsync({ id, workoutTypeData });
      return true;
    } catch (error) {
      // Error is already handled by the mutation's onError
      console.error('Update workout type error:', error);
      return false;
    }
  };

  const deleteWorkoutType = async (id: string) => {
    try {
      await deleteWorkoutTypeMutation.mutateAsync({ id, checkCanDelete: checkCanDeleteWorkoutType });
      return true;
    } catch (error) {
      // Error is already handled by the mutation's onError
      console.error('Delete workout type error:', error);
      return false;
    }
  };

  return {
    workoutTypes,
    loading,
    canManage,
    createWorkoutType,
    updateWorkoutType,
    deleteWorkoutType,
    checkCanDeleteWorkoutType,
    refetch
  };
};

export type { WorkoutTypeOperations, DeleteCheck } from './types';
